<div class="chart">
  <div class="chart__header">
    <h3 class="chart__title">{{ title }}</h3>
    <h4 class="chart__description">{{ description }}</h4>
  </div>
  <canvas class="chart__canvas" baseChart
          [type]="'pie'"
          [datasets]="pieChartDatasets"
          [labels]="pieChartLabels"
          [legend]="pieChartLegend"
          [options]="pieChartOptions">
  </canvas>
  <ul class="chart__legend">
    @for (i of _data; track i; let idx = $index) {
      <li [style]="{color:legendColors[idx]}"><strong>{{ i }}</strong>&nbsp;{{ getDeclensionOrganization(i) }}</li>
    }
    <li [style]="{color:'#000'}"><strong>{{ total }}</strong>&nbsp;{{ getDeclensionOrganization(total) }}</li>
  </ul>
</div>

